import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import SensorService from "../../../../services/sensor/SensorService";
import AuthService from "../../../../services/auth/AuthService";
import { colorPalette, monthNames } from "./chartOption";
import { useTranslation } from "react-i18next";

const QuantityMaterialPerMonth = () => {
    const [residualMaterial, setResidualMaterial] = useState<
        Map<string, number>
    >(new Map());
    const { t } = useTranslation(["sensor"]);
    useEffect(() => {
        const fetchResidualMaterialPerMonth = async () => {
            const userCompanyId = AuthService.user?.companyId || 0;
            const startDate = new Date();
            const endDate = new Date();

            return await SensorService.GetResidualMaterialPerMonth(
                userCompanyId,
                startDate,
                endDate
            );
        };

        fetchResidualMaterialPerMonth().then(setResidualMaterial);
    }, []);

    if (!residualMaterial) return <></>;
    const colors = colorPalette.slice(
        0,
        Array.from(residualMaterial.keys()).length
    );
    const chartData = {
        options: {
            chart: {
                id: "quantity",
            },
            xaxis: {
                categories: monthNames,
            },
            colors: colors,
            dataLabels: {
                enabled: false,
            },
            title: {
                text: 'Quantity of materials per month',
              },
        },
        series: [
            {
                name: t("sensor.chart:quantity"),
                data: Array.from(residualMaterial.values()),
            },
        ],
    };

    return (
        <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={300}
        />
    );
};

export default QuantityMaterialPerMonth;
